"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _config = require("../config");
var _helpers = require("react-platform-components/dist/helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    avatar: {
      '&.active': {
        background: theme.palette.third.secondary,
        color: "white"
      },
      background: theme.palette.third.main,
      marginRight: '1rem',
      width: theme.spacing(7),
      height: theme.spacing(7),
      color: theme.palette.third.secondary,
      fontSize: "xxx-large"
    },
    contactListItem: {
      '&.active': {
        '&::before': {
          backgroundColor: theme.palette.third.secondary,
          content: '""',
          display: 'block',
          height: '100%',
          position: 'absolute',
          right: 0,
          width: 3
        },
        backgroundColor: theme.palette.third.main
      },
      borderBottom: '1px solid ' + theme.palette.divider,
      minHeight: 90,
      padding: '12px 16px',
      backgroundColor: theme.palette.third.third
    },
    blackColor: {
      color: "black"
    }
  };
});
function ContactListItem(props) {
  var _contact$user, _contact$user2, _contact$user$avatar, _contact$product$unkn, _contact$product$cate;
  var classes = useStyles();
  var handleContactClick = function handleContactClick() {
    props.onContactClick(props.contact.id);
  };
  var handleShowProductInfo = function handleShowProductInfo(product) {
    return function () {
      window.open("".concat(_config.BASE_URL).concat(_config.PRODUCTS_ENDPOINT, "/").concat(product.id), '_blank');
    };
  };
  var contact = props.contact,
    selectedContactId = props.selectedContactId;
  // show the first name and the last name if exists
  var contactName = "".concat((_contact$user = contact.user) === null || _contact$user === void 0 ? void 0 : _contact$user.first_name, " ").concat(((_contact$user2 = contact.user) === null || _contact$user2 === void 0 ? void 0 : _contact$user2.last_name) || "");
  return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    button: true,
    className: (0, _classnames.default)(classes.contactListItem, {
      'active': selectedContactId === contact.id
    }),
    onClick: handleContactClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "relative"
  }, (_contact$user$avatar = contact.user.avatar) !== null && _contact$user$avatar !== void 0 && _contact$user$avatar.default ? /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: (0, _classnames.default)(classes.avatar, {
      "active": selectedContactId === contact.id
    }),
    alt: contactName,
    src: (0, _helpers.joinPaths)(_config.BASE_URL, contact.user.avatar.default)
  }) : /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: (0, _classnames.default)(classes.avatar, {
      "active": selectedContactId === contact.id
    }),
    alt: contactName
  }, contactName[0])), contact.product ? /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    classes: {
      root: "min-w-px",
      secondary: "truncate"
    },
    className: classes.blackColor,
    primary: contactName,
    secondary: _lodash.default.truncate((_contact$product$unkn = contact.product.unknown_category) !== null && _contact$product$unkn !== void 0 && _contact$product$unkn.parent_category ? "".concat(contact.product.unknown_category.parent_category.name, ", ").concat(contact.product.unknown_category.name) : (_contact$product$cate = contact.product.category) !== null && _contact$product$cate !== void 0 && _contact$product$cate.parent_category ? "".concat(contact.product.category.parent_category.name, ", ").concat(contact.product.category.name) : null, {
      length: 37
    })
  }) : /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    classes: {
      root: "min-w-px",
      secondary: "truncate"
    },
    primary: contactName
  }));
}
var _default = ContactListItem;
exports.default = _default;